import React, { useEffect, useState } from 'react'
import useNav from '../../../../hooks/useNav'
import { styles } from '../../../../styles/tailwind-config'
import { Label } from '../../../../components/ui/label'
import { DatePickerInput } from '../../../../components/ui/datepicker'
import { Input } from '../../../../components/ui/input'
import { Textarea } from '../../../../components/ui/textarea'
import { Button } from '../../../../components/ui/button'
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '../../../../components/ui/select'
import { AlertTriangleIcon, Loader2, SearchIcon } from 'lucide-react'
import SearchCustomer from '../../(components)/search-customer'
import { z } from 'zod'
import { addMinutes, format } from 'date-fns'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../../../context/AuthProvider';
import { useBoundStore } from '../../../../zustand'
import axios from '../../../../lib/axios'
import { useLingui, Trans } from '@lingui/react/macro'

const Main = () => {
    const { t } = useLingui()
    const navigate = useNavigate()
    const { setNav, nav } = useNav()

    useEffect(()=>{
        setNav({...nav, title:t`Oproep aanmaken`})
    }, [])

    const { auth } = useAuth()
    const technician = useBoundStore((state)=>state.technician)

    const [date, setdate] = useState<Date | undefined>(new Date());
    const [start_time, setstart_time] = useState(format(new Date(), "HH:mm"));
    const [end_time, setend_time] = useState(format(addMinutes(new Date(), 30), "HH:mm"));
    const [language, setlanguage] = useState('NL');
    const [description_problem, setdescription_problem] = useState('');
    const [intern_comment, setintern_comment] = useState('');

    const [customer, setcustomer] = useState<ICustomer | undefined>(undefined);

    async function validateHours() {
        try {
            const { data } = await axios.post('timeregistration/validate', {
                dbid: auth.data?.databases[0].dbid,
                technicianid: technician?.m_iTECHNIEKERID,
                interventionid: "0",
                date: date && format(date, "yyyyMMdd"),
                starttime: start_time,
                endtime: end_time,
            })
            console.log('timeregistration/validate', data)
        } catch (e) {
            throw new Error('Overlappende uren')
        }
    }

    const { mutate:createIntervention, isError, isPending } = useMutation({
        mutationFn: async () => {
            // await validateHours()

            let body = {
                interventionid: 0,
                customerid: customer?.m_iCUSTOMERID,
                locationid: customer?.m_iINSTALLLOCATIONID,
                machineid: 0,
                technicianid: technician?.m_iTECHNIEKERID,
                description: description_problem,
                date: date && format(date, "yyyyMMdd"),
                time: start_time.replace(':', ''),
                endtime: end_time.replace(':', ''),
                status: 1,
                intcomm: intern_comment,
                priority: 2,
                dtcreate: format(new Date(), "yyyyMMdd"),
                uscreate: technician?.m_sLOGIN,
                tel: customer?.m_sTEL,
                gsm: customer?.m_sGSM,
                email: customer?.m_sEMAIL,
                newrecordid: "",
                timestamp: format(new Date(), "yyyyMMddHHmmss"),
            }

            const { data } = await axios.post(`intervention/create?dbid=${auth.data?.databases[0].dbid}`, body)
            console.log('intervention', data)
        }, 
        onError: (e) => {
            toast.error(t`Er is een fout opgetreden bij het aanmaken van de interventie`)
            console.log(e)
        },
        onSuccess: () => {
            toast.success(t`Interventie is succesvol aangemaakt`)
            navigate('/startpagina')
        }
    })

    function isComplete () {
        try {
            z.object({
                date: z.string().min(1),
                customer: z.string().min(1),
                description: z.string().min(1),
            }).parse({
                date: date && format(date, "yyyyMMdd"),
                customer: customer?.m_sNAME || '',
                description: description_problem,
            })
            return true
        } catch (e) {
            console.log(e);
            return false
        }
    }

  return (
    <div className='flex flex-col gap-4 p-4'>
        <h1 className={styles.h1}><Trans>Interventie</Trans></h1>
        <div className='flex flex-wrap gap-2'>
            <div>
                <Label><Trans>Datum</Trans><span className='ml-1 text-red-600'>*</span></Label>
                <DatePickerInput value={date} onDateChange={(v)=>setdate(v)} />
            </div>
            <div>
                <Label><Trans>Startijd</Trans></Label>
                <Input type='time' value={start_time} onChange={(e)=>{setstart_time(e.currentTarget.value)}} />
            </div>
            <div>
                <Label><Trans>Eindtijd</Trans></Label>
                <Input type='time' value={end_time} onChange={(e)=>{setend_time(e.currentTarget.value)}}/>
            </div>
        </div>
        <div>
            <Label><Trans>Klant</Trans><span className='ml-1 text-red-600'>*</span></Label>
            <Input value={customer?.m_sNAME || ''} disabled endEnhancer={<SearchCustomer onPickCustomer={(customer)=>{setcustomer(customer)}} />}/>
        </div>
        <div>
            <Label><Trans>Taal (documenten)</Trans></Label>
            <Select value={language} onValueChange={(v)=>{setlanguage(v)}}>
                <SelectTrigger><SelectValue /></SelectTrigger>
                <SelectContent><SelectGroup>
                    <SelectItem value="NL"><Trans>Nederlands</Trans></SelectItem>
                    <SelectItem value="EN"><Trans>Engels</Trans></SelectItem>
                    <SelectItem value="FR"><Trans>Frans</Trans></SelectItem>
                </SelectGroup></SelectContent>
            </Select>
        </div>
        <div>
            <Label><Trans>Beschrijving van het probleem</Trans><span className='ml-1 text-red-600'>*</span></Label>
            <Textarea value={description_problem} onChange={(e)=>{setdescription_problem(e.currentTarget.value)}}/>
        </div>
        <div>
            <Label><Trans>Interne commentaar</Trans></Label>
            <Textarea value={intern_comment} onChange={(e)=>{setintern_comment(e.currentTarget.value)}}/>
        </div>
        <Button onClick={()=>{createIntervention()}} disabled={!isComplete() || isError || isPending}>
            {isPending && <Loader2 className='w-4 h-4 animate-spin'/>}
            {isError && <AlertTriangleIcon className='w-4 h-4'/>}
            <Trans>Oproep aanmaken</Trans>
        </Button>
    </div>
  )
}

export default Main